import {Inertia} from "@inertiajs/inertia";

export function formatAMPM(date) {
    var hours = date.getHours();
    var minutes = date.getMinutes();
    var ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    minutes = minutes < 10 ? "0" + minutes : minutes;
    var strTime = hours + ":" + minutes + " " + ampm;
    return strTime;
}

function format_two_digits(n) {
    return n < 10 ? "0" + n : n;
}

export function formatDateTypeTwo(date, type = 'date') {
    // let d = date.replace(/-/g, "/");
    let _date = new Date(date);

    if (type == 'time') {
        return (_date.toLocaleString("default", {month: "long"}) + " " + _date.getDate() + ", " + _date.getFullYear() + " " + format_two_digits(_date.getHours()) + ":" + format_two_digits(_date.getMinutes())

        );
    } else {
        return (_date.toLocaleString("default", {month: "long"}) + " " + _date.getDate() + ", " + _date.getFullYear());
    }
}

export function dateField(date, type = 'date') {
    // let d = date.replace(/-/g, "/");
    let _date = new Date(date);
    return (_date.getFullYear() + " " + _date.getMonth() + " " + _date.getDate());
}

export function inputDateFormat(date = null) {
    // let d = date.replace(/-/g, "/");
    let _date = (date == null) ? new Date() : new Date(date);
    return `${_date.getFullYear()}-${addLeadingZero(_date.getMonth() + 1)}-${addLeadingZero(_date.getDate())}`;
}

export function tableDate(date = null) {
    // let d = date.replace(/-/g, "/");
    let _date = (date == null) ? new Date() : new Date(date);
    return `${addLeadingZero(_date.getDate())}-${addLeadingZero(_date.getMonth() + 1)}-${_date.getFullYear()}`;
}

export function addLeadingZero(number) {
    return number.toString().padStart(2, '0');
}

export function separateCamelCase(str) {
    return str.replace(/([a-z])([A-Z])/g, '$1 $2');
}

export const getParameters = () => {
    let uri = window.location.href.split('?');
    if (uri?.length === 2) {
        let vars = uri[1].split('&');
        let getVars = {};
        let tmp = '';
        vars.forEach(function (v) {
            tmp = v.split('=');
            if (tmp?.length === 2) if (tmp[0] !== 'page') {
                getVars[tmp[0]] = decodeURIComponent(tmp[1]);
            }
        });
        return getVars;
    }
    return [];
}

export const makeParameter = (name = false, value = false, start = true) => {
    let data = getParameters();
    if (name) {
        if (typeof name == 'string') {
            data[name] = value;
        } else if (typeof name == 'object') {
            Object.keys(name).forEach((key) => {
                data[key] = name[key];
            })
        }
    }
    let param = '';
    Object.keys(data).forEach((key) => {
        if (data[key] != null) {
            param += (param === '' && start) ? '?' : '&';
            param += `${key}=${data[key]}`;
        }
    });
    return param;
}
export const setPath = (page) => {
    let url = window.location.origin;
    const pathname = window.location.pathname;
    if (pathname !== '/') {
        url = url + pathname;
    }
    Inertia.replace(url + page);
    // window.history.replaceState('', '', url + page);
}

export const formatDate = (date) => {
    const _date = new Date(date);

    return _date.getFullYear() + '-' + String(_date.getMonth() + 1).padStart(2, '0') + '-' + String(_date.getDate()).padStart(2, '0');
}
